module.exports = __webpack_public_path__ + "media/svg/be-7468913e.svg";